export const FETCH = 'offerzen/education/FETCH'
const FETCH_SUCCESS = 'offerzen/education/FETCH_SUCCESS'
const FETCH_ERROR = 'offerzen/education/FETCH_ERROR'

export const DELETE = 'offerzen/education/DELETE'
const DELETE_SUCCESS = 'offerzen/education/DELETE_SUCCESS'
const DELETE_ERROR = 'offerzen/education/DELETE_ERROR'

export const CREATE = 'offerzen/education/CREATE'
const CREATE_SUCCESS = 'offerzen/education/CREATE_SUCCESS'
const CREATE_ERROR = 'offerzen/education/CREATE_ERROR'

export const UPDATE = 'offerzen/education/UPDATE'
const UPDATE_SUCCESS = 'offerzen/education/UPDATE_SUCCESS'
const UPDATE_ERROR = 'offerzen/education/UPDATE_ERROR'

const ADD_TEMP_ITEM = 'offerzen/education/ADD_TEMP_ITEM'
const DELETE_TEMP_ITEM = 'offerzen/education/DELETE_TEMP_ITEM'

const TOGGLE_EDIT = 'offerzen/education/TOGGLE_EDIT'

export const SUBMIT = 'offerzen/education/SUBMIT'

export const SEARCH_UNIVERSITIES = 'offerzen/education/SEARCH_UNIVERSITIES'
const SEARCH_UNIVERSITIES_SUCCESS = 'offerzen/education/SEARCH_UNIVERSITIES_SUCCESS'
const SEARCH_UNIVERSITIES_ERROR = 'offerzen/education/SEARCH_UNIVERSITIES_ERROR'

export const SEARCH_DEGREES = 'offerzen/education/SEARCH_DEGREES'
const SEARCH_DEGREES_SUCCESS = 'offerzen/education/SEARCH_DEGREES_SUCCESS'
const SEARCH_DEGREES_ERROR = 'offerzen/education/SEARCH_DEGREES_ERROR'

// FETCH CREATORS
export const fetchEducation = candidateId => ({
  type: FETCH,
  meta: { candidateId },
})

export const fetchEducationSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: data,
})

export const fetchEducationError = errorMessage => ({
  type: FETCH_ERROR,
  payload: new Error(errorMessage),
})

export const createEducation = (candidateId, data, resolve, reject) => ({
  type: CREATE,
  meta: { candidateId, data, resolve, reject },
  payload: { loading: true },
})

export const createEducationSuccess = data => ({
  type: CREATE_SUCCESS,
  payload: data,
})

export const createEducationError = errorMessage => ({
  type: CREATE_ERROR,
  payload: new Error(errorMessage),
})

export const deleteEducation = (candidateId, id) => ({
  type: DELETE,
  meta: { id, candidateId },
})

export const deleteEducationSuccess = id => ({
  type: DELETE_SUCCESS,
  meta: { id },
})

export const deleteEducationError = errorMessage => ({
  type: DELETE_ERROR,
  payload: new Error(errorMessage),
})

export const updateEducation = (id, data, resolve, reject) => ({
  type: UPDATE,
  meta: { id, data, resolve, reject },
  payload: { loading: true },
})

export const updateEducationSuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: {
    ...data,
    loading: false,
  },
})

export const updateEducationError = errorMessage => ({
  type: UPDATE_ERROR,
  payload: new Error(errorMessage),
})

/*
 ** `tempId` is used as a unique identifier for new instances of EducationItemForm,
 ** only records that have not been persisted to the database will use `tempId`, those
 ** that have will use an `id` instead
 */
export const addBlankEducationItem = tempId => ({
  type: ADD_TEMP_ITEM,
  payload: {
    tempId,
    editing: true,
    isNew: true,
  },
})

export const deleteBlankEducationItem = tempId => ({
  type: DELETE_TEMP_ITEM,
  meta: { tempId },
})

export const toggleEducationEdit = (id, editing) => ({
  type: TOGGLE_EDIT,
  payload: { id, editing },
})

export const submit = (data, resolve, reject) => ({
  type: SUBMIT,
  meta: { resolve, reject },
  payload: { data },
})

export const searchUniversities = (id, term) => ({
  type: SEARCH_UNIVERSITIES,
  meta: { term },
  payload: {
    searchingUniversities: true,
    searchUniversitiesError: null,
    id,
  },
})

export const searchUniversitiesSuccess = (id, data) => ({
  type: SEARCH_UNIVERSITIES_SUCCESS,
  payload: {
    searchingUniversities: false,
    universitiesSearchResults: data,
    id,
  },
})

export const searchUniversitiesError = errorMessage => ({
  type: SEARCH_UNIVERSITIES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const searchDegrees = (id, term) => ({
  type: SEARCH_DEGREES,
  meta: { term },
  payload: {
    searchingDegrees: true,
    searchDegreesError: null,
    id,
  },
})

export const searchDegreesSuccess = (id, data) => ({
  type: SEARCH_DEGREES_SUCCESS,
  payload: {
    searchingDegrees: false,
    degreesSearchResults: data,
    id,
  },
})

export const searchDegreesError = errorMessage => ({
  type: SEARCH_DEGREES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

// REDUCERS
const initialEducation = {
  loading: false,
  editing: false,
  isNew: false,

  searchingUniversities: false,
  searchUniversitiesError: null,
  universitiesSearchResults: [],

  searchingDegrees: false,
  searchDegreesError: null,
  degreesSearchResults: [],

  university: '',
  degree: '',
}

const education = (state = initialEducation, { type, payload } = {}) => {
  switch (type) {
    case ADD_TEMP_ITEM:
    case CREATE_SUCCESS:
      return {
        ...state,
        ...payload,
      }

    case UPDATE:
    case TOGGLE_EDIT:
    case UPDATE_SUCCESS:
      if (state.id !== payload.id) return state

      return {
        ...state,
        ...payload,
      }

    case SEARCH_UNIVERSITIES:
    case SEARCH_DEGREES:
    case SEARCH_UNIVERSITIES_SUCCESS:
    case SEARCH_DEGREES_SUCCESS:
      const itemId = state.id || state.tempId
      if (itemId !== payload.id) return state

      return {
        ...state,
        ...payload,
      }

    case SEARCH_UNIVERSITIES_ERROR:
      return {
        ...state,
        searchingUniversities: false,
        searchUniversitiesError: payload,
      }

    case SEARCH_DEGREES_ERROR:
      return { ...state, searchingDegrees: false, searchDegreesError: payload }

    default:
      return {
        ...initialEducation,
        ...state,
      }
  }
}

const initialState = {
  data: [],
  fetching: true,
  error: null,
}

const entities = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_SUCCESS:
    case ADD_TEMP_ITEM:
      return {
        ...state,
        data: [...state.data, education(undefined, action)],
      }

    case DELETE_TEMP_ITEM:
      return {
        ...state,
        data: state.data.filter(item => item.tempId !== action.meta.tempId),
      }

    case DELETE_SUCCESS:
      return {
        ...state,
        data: state.data.filter(item => item.id !== action.meta.id),
      }

    case FETCH_SUCCESS:
      return {
        fetching: false,
        data: action.payload.map(item => education(item, action)),
      }

    case UPDATE:
    case TOGGLE_EDIT:
    case UPDATE_SUCCESS:
    case SEARCH_UNIVERSITIES:
    case SEARCH_UNIVERSITIES_SUCCESS:
    case SEARCH_UNIVERSITIES_ERROR:
    case SEARCH_DEGREES:
    case SEARCH_DEGREES_SUCCESS:
    case SEARCH_DEGREES_ERROR:
      return {
        ...state,
        data: state.data.map(item => education(item, action)),
      }

    default:
      return state
  }
}

export default entities

export const getEducation = state => state.education || initialState
